'use client';

import React from 'react';

export interface SeparatorProps extends React.HTMLAttributes<HTMLHRElement> {
  orientation?: 'horizontal' | 'vertical';
  decorative?: boolean;
  margin?: number | string;
  marginY?: number | string;
  marginX?: number | string;
  marginTop?: number | string;
  marginBottom?: number | string;
  marginLeft?: number | string;
  marginRight?: number | string;
  color?: string;
}

export const Separator = React.forwardRef<HTMLHRElement, SeparatorProps>(
  (
    {
      orientation = 'horizontal',
      decorative = true,
      margin,
      marginY,
      marginX,
      marginTop,
      marginBottom,
      marginLeft,
      marginRight,
      color = '#e5e7eb',
      style,
      ...props
    },
    ref
  ) => {
    const isHorizontal = orientation === 'horizontal';

    const toRem = (val: number | string | undefined) => {
      if (val === undefined) return undefined;
      const num = typeof val === 'string' ? parseFloat(val) : val;
      return `${num * 0.25}rem`;
    };

    const mt =
      toRem(marginTop) ?? toRem(marginY) ?? toRem(margin) ?? (isHorizontal ? '0.75rem' : '0');
    const mb =
      toRem(marginBottom) ?? toRem(marginY) ?? toRem(margin) ?? (isHorizontal ? '0.75rem' : '0');
    const ml =
      toRem(marginLeft) ?? toRem(marginX) ?? toRem(margin) ?? (isHorizontal ? '0' : '0.75rem');
    const mr =
      toRem(marginRight) ?? toRem(marginX) ?? toRem(margin) ?? (isHorizontal ? '0' : '0.75rem');

    const hrStyle: React.CSSProperties = isHorizontal
      ? {
          border: 'none',
          borderTop: `1px solid ${color}`,
          margin: `${mt} ${mr} ${mb} ${ml}`,
          width: '100%',
        }
      : {
          border: 'none',
          borderLeft: `1px solid ${color}`,
          margin: `${mt} ${mr} ${mb} ${ml}`,
          height: '100%',
          display: 'inline-block',
        };

    return (
      <hr
        ref={ref}
        role={decorative ? 'none' : 'separator'}
        aria-orientation={orientation}
        style={{ ...hrStyle, ...style }}
        {...props}
      />
    );
  }
);

Separator.displayName = 'Separator';
